// src/pages/Analytics.js
import React, { useEffect, useState } from 'react';
import { analyticsAPI } from '../utils/api';

export default function Analytics() {
  const [overview, setOverview] = useState(null);
  const [platforms, setPlatforms] = useState([]);
  const [days, setDays] = useState(30);

  useEffect(() => {
    analyticsAPI.overview(days).then(r => {
      setOverview(r.data.overview);
      setPlatforms(r.data.platforms);
    }).catch(() => {});
  }, [days]);

  const cards = [
    { label: 'Total Reach', value: overview?.total_reach || 0, chg: '+18%', up: true },
    { label: 'Engagements', value: overview?.total_engagements || 0, chg: '+11%', up: true },
    { label: 'Posts Published', value: overview?.total_posts || 0, chg: '-2', up: false },
    { label: 'Avg Engagement Rate', value: `${overview?.engagement_rate || 0}%`, chg: '+0.6%', up: true },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="page-header">
        <span className="page-title">Analytics</span>
        <div style={{ display: 'flex', gap: 8 }}>
          <select className="filter-pill" value={days} onChange={e => setDays(Number(e.target.value))}>
            <option value={7}>Last 7 days</option>
            <option value={30}>Last 30 days</option>
            <option value={90}>Last 90 days</option>
          </select>
          <button className="filter-pill">⬇ Export</button>
        </div>
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: 16 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10, marginBottom: 14 }}>
          {cards.map(c => (
            <div key={c.label} className="card" style={{ padding: 13 }}>
              <div style={{ fontSize: 22, fontWeight: 700, color: '#1a1f2e' }}>{typeof c.value === 'number' ? c.value.toLocaleString() : c.value}</div>
              <div style={{ fontSize: 11, color: '#8892a4', marginTop: 2 }}>{c.label}</div>
              <div style={{ fontSize: 11, fontWeight: 600, marginTop: 5, color: c.up ? '#059669' : '#e55b2d' }}>{c.up ? '↑' : '↓'} {c.chg} vs last period</div>
            </div>
          ))}
        </div>
        <div className="card" style={{ marginBottom: 12 }}>
          <div className="card-header"><span className="card-title">Engagement by Platform</span></div>
          <div style={{ padding: 14 }}>
            {platforms.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 30, color: '#aaa', fontSize: 12 }}>No analytics data yet — start publishing posts to see your stats</div>
            ) : platforms.map(p => (
              <div key={p.platform} style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, marginBottom: 4 }}>
                  <span style={{ color: '#555' }}>{p.platform}</span>
                  <span style={{ fontWeight: 600, color: '#1a1f2e' }}>{p.engagements}</span>
                </div>
                <div style={{ height: 7, background: '#f0f1f5', borderRadius: 4 }}>
                  <div style={{ width: `${Math.min(100, (p.engagements / (platforms[0]?.engagements || 1)) * 100)}%`, height: 7, borderRadius: 4, background: '#0f766e' }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

